module.exports = __webpack_public_path__ + "static/media/10.f2247ef2.png";